import {ChangeDetectionStrategy, Component, ElementRef, forwardRef, Injector, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AutocompleteProviderConfig, DefinedListAutocompleteService} from '../../autocomplete';
import {AutocompleteInputComponent} from '../../autocomplete-input';
import {InvEntity} from '../inv-portfolio';
import {InvPortfolioService} from '../inv-portfolio.service';

@Component({
    selector: 'inv-entity-id-select',
    templateUrl: '../../../components/autocomplete-input/autocomplete-input.component.html',
    styleUrls: ['../../autocomplete-input/autocomplete-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InvEntityIdSelectComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvEntityIdSelectComponent extends AutocompleteInputComponent<number, InvEntity>
    implements OnInit {

    constructor(
        elementRef: ElementRef,
        injector: Injector,
        private invPortfolioService: InvPortfolioService
    ) {
        super(elementRef, injector);
    }

    public override ngOnInit(): void {
        this.initAutocompleteConfig();

        super.ngOnInit();
    }

    protected override outerValueToInnerValue(outerValue: number): InvEntity {
        return outerValue && this.invPortfolioService.getInvEntity(outerValue, true) || null;
    }

    protected override innerValueToOuterValue(innerValue: InvEntity): number {
        return innerValue && innerValue.id || null;
    }

    private initAutocompleteConfig(): void {
        const {invEntities} = this.invPortfolioService.getCached();

        const autocompleteProvider = new DefinedListAutocompleteService<InvEntity>({
            list:          [...invEntities]
                               .sort((invEntity1, invEntity2) =>
                                   invEntity1.code.localeCompare(invEntity2.code, undefined, {numeric: true})
                               ),
            filterByField: 'code'
        });

        this.autocompleteConfig = {
            type:                      {
                                           provider: autocompleteProvider
                                       } as AutocompleteProviderConfig<InvEntity>,
            displayValue:              (invEntity: InvEntity) => invEntity && invEntity.code || '',
            allowVariantsForEmptyTerm: true,
            disallowEmptySelect:       true,
            selectAllOnFocus:          true
        };
    }

}
